import { render } from "./ReviewsView.vue?vue&type=template&id=675c3edb&scoped=true"
import script from "./ReviewsView.vue?vue&type=script&lang=js"
export * from "./ReviewsView.vue?vue&type=script&lang=js"

import "./ReviewsView.vue?vue&type=style&index=0&id=675c3edb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675c3edb"]])

export default __exports__